<!--<h4>Calendar</h4>-->
<p>
    The Calendar widget integrates information from the school-wide calendar plus any Canvas assignment due dates.  The school-wide calendar is available here: <a href="https://calendars.kenan-flagler.unc.edu/MasterCalendar.aspx" target="_blank">https://calendars.kenan-flagler.unc.edu/MasterCalendar.aspx</a>
</p>
